// Auto generated file, do not manually modify!
// com.hotpads.customeranalytics.enums.BuildingPhotographyStatus

export enum BuildingPhotographyStatus {
  EXPIRED_VOUCHER = 'EXPIRED_VOUCHER',
  NOT_INTERESTED = 'NOT_INTERESTED',
  RECEIVED_VOUCHER = 'RECEIVED_VOUCHER',
  REDEEMED_VOUCHER = 'REDEEMED_VOUCHER',
}

export const BuildingPhotographyStatus_values = [
  BuildingPhotographyStatus.EXPIRED_VOUCHER,
  BuildingPhotographyStatus.NOT_INTERESTED,
  BuildingPhotographyStatus.RECEIVED_VOUCHER,
  BuildingPhotographyStatus.REDEEMED_VOUCHER,
] as const;
